import {
    GET_ALL_SCANS,
    ADD_SCAN,
    EDIT_SCAN,
    DELETE_SCAN,
    INSERT_SCANS,
    GET_SCAN_COUNT,
    GET_SCAN_LIST
} from '../actions/ScanActions'
import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = {
    key: 'scans',
    storage,
};

const initialState = {
    data: [],
    totalScans: 0,
    totalPages: 0,
    currentPage: 1,

    latestUpdate: '',
    loading: false,
    error: '',

    scanCount: {
        "exhibitorToday": null,
        "exhibitorAllTime": null
    },
    scansList:{
        "booth": null,
        "allBooths": null, // All booths in event
        "activity": null,
        "allActivity": null, // All activities in event
    }
}

const ScanReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_SCAN: {
            let tempArray = Object.assign({}, state.allScans)
            tempArray.rows = [action.payload, ...state.allScans.rows]
            return {
                ...state,
                allScans: tempArray,
            }
        }
        case EDIT_SCAN: {
            let tempArray = Object.assign({}, state.allScans)
            let target = tempArray.rows.findIndex(item => { return item.id == action.payload.id })
            tempArray.rows[target] = action.payload
            return {
                ...state,
                allScans: tempArray,
            }
        }
        case DELETE_SCAN: {
            let tempArray = Object.assign({}, state.allScans)
            let newArray = tempArray.rows.filter(item => { return item.id !== action.payload })
            tempArray.rows = newArray
            return {
                ...state,
                allScans: tempArray,
            }
        }
        case GET_ALL_SCANS: {
            return {
                ...state,
                data: action.payload.scans.scans,
                currentPage: action.payload.scans.currentPage,
                totalScans: action.payload.scans.totalElements,
                totalPages: action.payload.scans.totalPages,
            }
        }
        case INSERT_SCANS: {
            const newScan = action.payload.scans; // assuming you're passing just one scan now
            const updatedData = [newScan, ...state.data];
            const updatedTotalScans = state.totalScans + 1;
            const updatedTotalPages = Math.ceil(updatedTotalScans / state.pageSize); // assuming you have pageSize in your state

            return {
                ...state,
                data: updatedData,
                totalScans: updatedTotalScans,
                totalPages: updatedTotalPages,
                // currentPage may remain the same, or you can update based on needs
            };
        }
        case GET_SCAN_COUNT: {
            return {
                ...state,
                scanCount: {
                    ...state.scanCount,
                    [action.payload.key] : action.payload.count
                },
            }
        }
        case GET_SCAN_LIST: {
            return {
                ...state,
                scansList: {
                    ...state.scansList,
                    [action.payload.key] : action.payload.scans
                },
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default persistReducer(persistConfig, ScanReducer);
